module.exports = __webpack_public_path__ + "media/images/UCI-logo@2x-38ddf49312547c2a8d6f992f2192f871.jpg";